export enum PROVIDER {
  Provider = 'Providers'
}

export enum PROVIDER_ENDPOINTS {
  GetAll = 'GetAll',
  Delete = 'Delete',
  GetProviderCount = 'GetProviderCount'
}

export enum LOOKUPS {
  Lookups = 'Lookups'
}

export enum LOOKUPS_ENDPOINTS {
  GetLookup = 'GetLookup'
}

export enum SPECIALTY {
  Specialty = 'Specialties'
}

export enum SPECIALTY_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum CPT_CODE {
  CptCode = 'CptCodes'
}

export enum CPT_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum ICD10_CODE {
  Icd10Code = 'Icd10Codes'
}

export enum ICD10_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum MODIFIER_CODE {
  ModifierCode = 'ModifierCodes'
}

export enum MODIFIER_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum PLACE_OF_SERVICE {
  PlaceOfService = 'PlaceOfServices'
}

export enum PLACE_OF_SERVICE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum RELATIONSHIP_CODE {
  RelationshipCode = 'RelationshipCodes'
}

export enum RELATIONSHIP_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum GENDER_CODE {
  GenderCode = 'GenderCodes'
}

export enum GENDER_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum SERVICE_TYPE_CODE {
  ServiceTypeCode = 'ServiceTypeCodes'
}

export enum SERVICE_TYPE_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum REVENUE_CODE {
  RevenueCode = 'RevenueCodes'
}

export enum REVENUE_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum UNIT_TYPE_CODE {
  UnitTypeCode = 'UnitTypeCodes'
}

export enum UNIT_TYPE_CODE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum TIMING {
  Timing = 'Timing'
}

export enum TIMING_ENDPOINTS {
  GetTimezones = 'GetTimezones'
}
export enum LOCATION {
  Locations = 'Locations'
}

export enum LOCATION_ENDPOINTS {
  GetAll = 'GetAll',
  Delete = 'Delete'
}

export enum PAYOR {
  Payor = 'Payors'
}

export enum PAYOR_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum PAYOR_MAPPING {
  PayorMapping = 'PayorMappings'
}

export enum PAYOR_MAPPING_ENDPOINTS {
  GetAll = 'GetAll',
  GetPayorMappingForView = 'GetPayorMappingForView',
  GetPayorMappingForEdit = 'GetPayorMappingForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum CLEARING_HOUSE {
  ClearingHouse = 'ClearingHouses'
}

export enum CLEARING_HOUSE_ENDPOINTS {
  GetAll = 'GetAll'
}

export enum LOCATION_GROUP {
  LocationGroup = 'LocationGroups'
}

export enum LOCATION_GROUP_ENDPOINTS {
  GetAll = 'GetAll',
  GetLocationGroupForView = 'GetLocationGroupForView',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum LOCATION_GROUP_MEMBER {
  LocationGroupMembers = 'LocationGroupMembers'
}

export enum LOCATION_GROUP_MEMBER_ENDPOINTS {
  GetAll = 'GetAll',
  GetLocationGroupMemberForView = 'GetLocationGroupMemberForView',
  GetLocationGroupMemberForEdit = 'GetLocationGroupMemberForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum NETWORK_STATUS {
  NetworkStatuses = 'NetworkStatuses'
}

export enum NETWORK_STATUS_ENDPOINTS {
  GetAll = 'GetAll',
  GetNetworkStatusForView = 'GetNetworkStatusForView',
  GetNetworkStatusForEdit = 'GetNetworkStatusForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum PATIENT_COVERAGE {
  PatientCoverages = 'PatientCoverages'
}

export enum PATIENT_COVERAGE_ENDPOINTS {
  GetAll = 'GetAll',
  GetPatientCoverageForView = 'GetPatientCoverageForView',
  GetPatientCoverageForEdit = 'GetPatientCoverageForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete',
  UploadAttachment = 'UploadAttachment'
}

export enum PATIENT {
  Patients = 'Patients'
}

export enum PATIENT_ENDPOINTS {
  GetAll = 'GetAll',
  GetPatientForView = 'GetPatientForView',
  GetPatientForEdit = 'GetPatientForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum INSURANCE_PLAN {
  InsurancePlans = 'InsurancePlans'
}

export enum INSURANCE_PLAN_ENDPOINTS {
  GetAll = 'GetAll',
  GetInsurancePlanForView = 'GetInsurancePlanForView',
  GetInsurancePlanForEdit = 'GetInsurancePlanForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum ELIGIBILITY_REQUEST {
  EligibilityRequests = 'EligibilityRequests'
}

export enum ELIGIBILITY_REQUEST_ENDPOINTS {
  GetAll = 'GetAll',
  GetEligibilityRequestForView = 'GetEligibilityRequestForView',
  GetEligibilityRequestForEdit = 'GetEligibilityRequestForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete',
  GenerateEligibilityPDF = 'GenerateEligibilityPDF'
}
export enum ELIGIBILITY_RESPONSE {
  EligibilityResponses = 'EligibilityResponses'
}

export enum ELIGIBILITY_RESPONSE_ENDPOINTS {
  GetAll = 'GetAll',
  GetEligibilityResponseForView = 'GetEligibilityResponseForView',
  GetEligibilityResponseForEdit = 'GetEligibilityResponseForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete',
  Count = 'Count'
}

export enum ELIGIBILITY_RESPONSE_BENEFIT {
  EligibilityResponseBenefits = 'EligibilityResponseBenefits'
}

export enum ELIGIBILITY_RESPONSE_BENEFIT_ENDPOINTS {
  GetAll = 'GetAll',
  GetEligibilityResponseBenefitForView = 'GetEligibilityResponseBenefitForView',
  GetEligibilityResponseBenefitForEdit = 'GetEligibilityResponseBenefitForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete'
}

export enum ELIGIBILITY_REQUEST_STATUS {
  EligibilityRequestStatuses = 'EligibilityRequestStatuses'
}

export enum ELIGIBILITY_REQUEST_STATUS_ENDPOINTS {
  GetAll = 'GetAll',
  GetEligibilityRequestStatusForView = 'GetEligibilityRequestStatusForView',
  GetEligibilityRequestStatusForEdit = 'GetEligibilityRequestStatusForEdit',
  CreateOrEdit = 'CreateOrEdit',
  Delete = 'Delete',
  Count = 'Count'
}